<template>
    <form @submit.prevent="onFormSubmit">
        <div>
             <the-input
                type="number"
                name="networkId"
                :label="'ID Sieci'"
                required
                v-model="networkId"
            />
            <the-input
                :invalid="!!pinError"
                :invalidFeedback="pinError"
                type="number"
                name="pin"
                :label="'PIN'"
                required
                v-model="pin"
            />
        </div>
        <div>
            <ui-checkbox-input
                class="custom-control custom-checkbox mb-2"
                v-for="(agreement, agreementIdx) in agreements"
                :key="agreementIdx"
                :name="'add-store-to-network-agreement-'+agreementIdx"
                required
                v-model="agreement.value"
                :label="agreement.text"
            />
        </div>
        <div>
            <div v-if="showFormError" class="text-danger m-3">
                Uwaga! W celu dołączenia sklepów do Sieci uzupełnij pola oraz zaznacz wszystkie powyższe zgody.
            </div>
            <div class="d-flex justify-content-between m-2 mt-5 buttons-wrapper">
                <the-btn
                    @click.native="cancelClick"
                    :text="'Anuluj'"
                    :btnClass="'btn btn-outline-primary '"
                    type='button'
                ></the-btn>
                <the-btn
                    @click.native="submitButtonClick"
                    :text="'Potwierdzam'"
                    :btnClass="'btn btn-primary'"
                ></the-btn>
            </div>
       </div>
    </form>
</template>

<script>

export default{
    name: 'AddStoresToNetworkForm',
    props: {
        pinError: {
            type: String,
            default: ''
        }
    },
    data() {
        return{
            submitButtonFired: false,
            networkId: null,
            pin: null,
            agreements: [
                {
                    text: 'Zgoda na dostęp Partnera (Założyciela Sieci) do danych transakcyjnych: Wyrażam zgodę na dostęp Partnera do danych transakcyjnych dotyczących Promocji (w szczególności do danych lokalizacyjnych i elektronicznych), rejestrowanych przez Urządzenia, znajdujące się w będących moją własnością punktach handlowych lub usługowych, które zgodnie z moją decyzją należeć będą do Sieci.',
                    value: false
                },
                {
                    text: 'Zgoda na przekazywanie danych transakcyjnych innym uczestnikom Sieci: Wyrażam zgodę na przekazywanie przez Partnera Użytkownikom uzyskanych przez Partnera uprawnień w zakresie dostępu do danych transakcyjnych dotyczących Promocji (w szczególności do danych lokalizacyjnych i elektronicznych), rejestrowanych przez znajdujące się w będących moją własnością punktach handlowych lub usługowych, które zgodnie z moją decyzją należeć będą do Sieci, w szczególności w celu oferowania Uczestnikom Sieci Promocji.',
                    value: false
                },
                {
                    text: 'Zgoda na zarządzanie promocjami: Wyrażam zgodę na dokonywanie przez Partnera wyboru Promocji oraz warunków tych promocji (zmiana ceny max), jakie obowiązywać będą w Sieci.',
                    value: false
                }

            ]
        }
    },
    computed: {
        formValid() {
            const agreementsValid = this.agreements.every(agreement => agreement.value)
            const inputsValid = this.networkId && this.pin
            return !!agreementsValid && !!inputsValid
        },
        showFormError() {
            return !this.formValid && this.submitButtonFired
        }
    },
    methods: {
        cancelClick() {
            this.$emit('cancel')
        },
        submitButtonClick() {
            this.submitButtonFired = true
        },
        onFormSubmit() {
            if(this.formValid) {
                this.$emit('submit', { pin: this.pin, networkId: this.networkId })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/_custom.scss';
@import "~bootstrap/scss/mixins";

.buttons-wrapper{
    flex-direction: column;
     @include media-breakpoint-up(sm) {
        flex-direction: row;
    }

    button{
        margin-bottom:10px;
        @include media-breakpoint-up(sm) {
            margin: 0;
            padding-left: 5rem;
            padding-right: 5rem;
        }
        &:last-of-type{
            margin: 0;
        }
    }
}
</style>